import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageHeading } from '../../../../components/page-components/PageHeading';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { EngineeringReviewOrderRow } from '../components/EngineeringReviewOrderRow';
import { EngineeringReviewList } from '../../../../modules/ordering/models/engineering-review-list';
import { EngineeringReviewSearchFilters } from '../../../../modules/ordering/models/engineering-review-search-filters';
import "../../../../modules/ordering/styles.scss";
import { OrderingSvc } from '../../../../modules/ordering/service';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { DocumentEngineeringReviewQueryExport } from '../../../../modules/ordering/models/engineering-review-query-document';
import { OrderDetailFlyout } from '../../../../modules/ordering/components/OrderDetailFlyout';
import { OrderHistory } from '../../../../models/ordering/order-history';

export const EngineeringScene = () => {

    const dispatch = useDispatch();
    const [service] = React.useState(new OrderingSvc());
    const [filterParams, setFilterParams] = React.useState(new EngineeringReviewSearchFilters());
    const [isFlyoutOpen, setIsFlyoutOpen] = React.useState(false);
    const [orderObj, setOrderObj] = React.useState<any>({});
    const [orderHistory, setOrderHistory] = React.useState<any>([]);
    const [orders, setOrders] = React.useState(() => {
        const initial = new PagedApiResult<EngineeringReviewList>();
        initial.pagination = filterParams.paginationInfo;
        initial.pagination.reusePaging = true;
        return initial;
    });

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: EngineeringReviewSearchFilters) => {
        const response = await service.search(EngineeringReviewList, filters);
        if (response.status === StatusCode.Success) {
            setOrders(response.data);
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm: any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new EngineeringReviewSearchFilters();
        setFilterParams(tmp);
    };

    const exportQuery = async () => {
        const req = new DocumentEngineeringReviewQueryExport(filterParams);
        dispatch(getDocumentHelper(req));
    };

    const getOrderDetails = async (orderId: string) => {

        let shouldOpen = true;

        const detailsResult = await service.getOrder(orderId);
        if (detailsResult.status === StatusCode.Success) {
            setOrderObj(detailsResult.data);
        }
        else {
            setOrderObj({});
            shouldOpen = false;
        }

        const historyResult = await service.getOrderHistory(orderId);
        if (historyResult.status === StatusCode.Success) {
            setOrderHistory(historyResult.data);
        }
        else {
            setOrderHistory({} as unknown as OrderHistory);
            shouldOpen = false;
        }

        if (shouldOpen) {
            setIsFlyoutOpen(true);
        }

    };

    /**
     * Close the flyout
     */
    const closeFlyout = () => {
        setIsFlyoutOpen(false);
        setOrderObj({});
        setOrderHistory([]);
    };

    return <PageContent pageName={PageNames.ORDERING_ENGINEERING_REVIEW}>
        <PageHeading>
            <HasPermission requiredPermissions={[
                Permissions.ApprovalsEngineering
            ]}>
                <button className="btn new attention" onClick={ exportQuery }>
                    Export
                </button>
            </HasPermission>
        </PageHeading>
        <PageBody>

            <PagedList
                noResultsMessage="No engineering review orders found, please search again."
                searchCallback={onSearch}
                data={orders}
                filterProps={filterParams}
                selectableClass=""
                onFilterUpdate={onParamsUpdate}
                onReset={onParamsReset}
                hidePager={true}
                rowRenderer={(order: EngineeringReviewList) =>
                    <EngineeringReviewOrderRow
                        key={order.id}
                        order={order}
                        onOrderClick={getOrderDetails}
                    />
                }
            />

            <OrderDetailFlyout
                isOpen={isFlyoutOpen}
                onClose={closeFlyout}
                orderObj={orderObj}
                orderHistory={orderHistory}
            />

        </PageBody>
    </PageContent>;
};
